import * as DashboardConstants from '.././DashboardConstants';

export const BotPerformanceTableHeaders = [
    {
        key: 'franchise',
        header: DashboardConstants.Franchise
    },
    {
        key: 'process',
        header: DashboardConstants.ProcessNumber
    },
    {
        key: 'executions',
        header: DashboardConstants.Executions
    },
    {
        key: 'termination',
        header: DashboardConstants.Terminations
    },
    {
        key: 'completed',
        header: DashboardConstants.Completed
    },
    {
        key: 'terminationrate',
        header: DashboardConstants.TerminationsRate
    }
];

export const firstTimetableHeaders = [
    {
        key: 'botId',
        header: DashboardConstants.botID
    },
    {
        key: 'totalRuns',
        header: DashboardConstants.totalRuns
    },
    // {
    //     key: 'totalSuccess',
    //     header: DashboardConstants.totalSuccess
    // },
    {
        key: 'successOnFirstRun',
        header: DashboardConstants.SuccessOn1stRun
    },
    {
        key: 'successOf1stRun',
        header: DashboardConstants.FirstRunSuccessPercent
    },
    {
        key: 'status',
        header: DashboardConstants.Status
    }
]



// export const BotPerformanceTableData = [
//     {
//         id:1,
//         'Franchise':123,
//         'Process No.':133,
//         'Executions':212,
//         'Completed':567,
//         'Termination':123,
//         'Termination Rate %':'23%',
//     },
//     {
//         id:2,
//         'Franchise':675,
//         'Process No.':24,
//         'Executions':87,
//         'Completed':234,
//         'Termination':12,
//         'Termination Rate %':'89%',
//     },
//     {
//         id:3,
//         'Franchise':88,
//         'Process No.':66,
//         'Executions':78,
//         'Completed':456,
//         'Termination':123,
//         'Termination Rate %':'90%',
//     },
// ]